import Button from "@/common/components/Button";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { SearchIcon } from "lucide-react";
import { objectiveSystemsTableColumns } from "../../constants/objectiveSystemsTableColumns.constant";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { useNavigate } from "react-router-dom";
import { useMaintenanceObjectiveSystems } from "../../hooks/useMaintenanceObjectiveSystems";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { MaintenanceObjectiveSystemsTransformer } from "../../services/maintenanceObjectiveSystemsTransformer";

const MaintenanceObjectiveSystemsList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const navigate = useNavigate();

  const [search, setSearch] = useDebounce(filterParams.search);

  const {
    data: maintenanceObjectiveSystems,
    isPending: isMaintenanceObjectiveSystemsPending,
    meta: maintenanceObjectiveSystemsMeta,
    refetch: refetchMaintenanceObjectiveSystems,
    error: maintenanceObjectiveSystemsError = {} as any,
  } = useMaintenanceObjectiveSystems({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: MaintenanceObjectiveSystemsTransformer.tableTransformer(),
    }),
  });

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-156px)]"
      refetchFunction={refetchMaintenanceObjectiveSystems}
      statusCode={maintenanceObjectiveSystemsError?.status}
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-4">
          <TextField
            name="search"
            LeftIcon={<SearchIcon />}
            placeholder="Pesquisar"
            className="rounded-sm shadow-xl"
            onChange={(e) => {
              setSearch((e.target as HTMLInputElement).value);
              setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
            }}
            value={filterParams.search}
          />

          <div className="flex items-center justify-between">
            <Button
              name="create"
              operationKlassToCheckPermission="Admin::Maintenance::ObjectiveSystems::Create"
              onClick={() => navigate('create')}
              className="ml-auto"
            >
              Novo Sistema
            </Button>
          </div>
        </div>

        <Table
          className="h-[calc(100vh-320px)]"
          columns={objectiveSystemsTableColumns}
          rows={maintenanceObjectiveSystems}
          page={Number(filterParams.page) || 1}
          totalPages={maintenanceObjectiveSystemsMeta.total_pages}
          totalCount={maintenanceObjectiveSystemsMeta.total}
          hasPagination
          setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          rowEmptyValue="--"
          isLoadingData={isMaintenanceObjectiveSystemsPending}
        />
      </div>
    </ErrorMessageWrapper>
  );
}

export default MaintenanceObjectiveSystemsList;
